import { DateColumn, Delimiter, Typography } from '@otp/ui';
import { User } from 'src/graphql/generated/graphql';
import { getFullName } from 'src/utils/user-data';
import { CommentForm, Form } from './form';
import { Comment as CommentIcon } from '@otp/icons';

type Comment = {
  id: string;
  comment: string;
  createdBy: Pick<User, 'id' | 'firstName' | 'lastName'>;
  createdAt?: string;
};

type CommentsProps = {
  comments: Comment[];
  title: string;
  onNewComment?: (form: Form) => void;
  loading: boolean;
};

export const Comments = ({
  comments,
  title,
  onNewComment,
  loading,
}: CommentsProps) => {
  return (
    <div>
      {onNewComment && <CommentForm onSave={onNewComment} loading={loading} />}
      {comments.length > 0 && (
        <Typography
          variant="subtitle1"
          className="mb-4 font-bold flex flex-row gap-2"
        >
          <CommentIcon /> {title} ({comments.length})
        </Typography>
      )}
      {comments.map((comment) => (
        <div key={comment.id}>
          <div className="flex flex-row gap-2 justify-between">
            <Typography variant="subtitle2" className="font-bold">
              {getFullName(comment.createdBy, ' ')}
            </Typography>
            <Typography variant="subtitle2">
              {comment.createdAt && (
                <DateColumn date={comment.createdAt} withTime={true} />
              )}
            </Typography>
          </div>
          <Typography variant="subtitle2" className="my-2">
            <div dangerouslySetInnerHTML={{ __html: comment.comment }} />
          </Typography>
          <Delimiter className="my-2" />
        </div>
      ))}
    </div>
  );
};
